module.exports = __webpack_public_path__ + "static/media/03n.d9d97549.png";